import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select, Spin } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
import * as bootstrap from "bootstrap";

const ConfigrationModel = ({ record }) => {
  console.log(record, "ssssssssssssssssssssssss");
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [processingTypeOptions, setProcessingTypeOptions] = useState([]);
  console.log(processingTypeOptions, "processssssssssss");
  const [priorityTypeOptions, setPriorityTypeOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  console.log(productTypeOptions, "productTypeOptions");
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  console.log(planTypeOptions, "planTypeOptions");

  const [deviceLogicOptions, setDeviceLogicOptions] = useState([]);
  const userData = JSON.parse(sessionStorage.getItem("HealthCheckuser"));

  const [configData, setConfigData] = useState({
    SuperId: record?.SuperId,
    UserId: userData?.[0]?.UserId,
    ProcessingTypeId: null,
    PriorityTypeId: null,
    ProductTypeId: null,
    PlanTypeId: null,
    DeviceLogicTypeId: null,
  });

  console.log(configData, "configdata..............");

  const getDropdowns = async () => {
    try {
      console.log("Dropdown API calling");

      const processingRes = await axios.get(
        `${API_BASE_URL}api/type/getprocessingtype`
      );

      console.log(processingRes.data, "processingRes");

      setProcessingTypeOptions(
        processingRes.data.ResultData?.map((item) => ({
          label: item.Name,
          value: item.Id,
        })) || []
      );

      const productRes = await axios.get(
        `${API_BASE_URL}api/type/getproducttype`
      );

      console.log(productRes.data, "productRes");
      setProductTypeOptions(
        productRes.data.ResultData?.map((item) => ({
          label: item.ProductName,
          value: item.Id,
        })) || []
      );

      const priorityRes = await axios.get(
        `${API_BASE_URL}api/type/getprioritytype`
      );

      setPriorityTypeOptions(
        priorityRes.data.ResultData?.map((item) => ({
          label: item.Name,
          value: item.Id,
        })) || []
      );

      const planRes = await axios.get(`${API_BASE_URL}api/type/getplantype`);

      setPlanTypeOptions(
        planRes.data.ResultData?.map((item) => ({
          label: item.Name,
          value: item.Id,
        })) || []
      );

      const deviceLogicRes = await axios.get(
        `${API_BASE_URL}api/type/getdevicelogictype`
      );

      setDeviceLogicOptions(
        deviceLogicRes.data.ResultData?.map((item) => ({
          label: item.Name,
          value: item.Id,
        })) || []
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("useEffect Triggered");
    getDropdowns();
  }, []);

  const getConfiguration = async (SuperId) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_BASE_URL}api/org/getconfiguration?SuperId=${SuperId}`
      );

      if (
        res.data.status &&
        res.data.ResultData &&
        res.data.ResultData.length > 0
      ) {
        const data = res.data.ResultData[0];

        setIsEdit(true);

        setConfigData({
          SuperId: record?.SuperId,
          UserId: userData?.[0]?.UserId,
          ProcessingTypeId: data.ProcessingTypeId || null,
          PriorityTypeId: data.PriorityTypeId || null,
          ProductTypeId: data.ProductTypeId || null,
          PlanTypeId: data.PlanTypeId || null,
          DeviceLogicTypeId: data.DeviceLogicTypeId || null,
        });
      } else {
        setIsEdit(false);

        setConfigData({
          SuperId: record?.SuperId,
          UserId: userData?.[0]?.UserId,
          ProcessingTypeId: null,
          PriorityTypeId: null,
          ProductTypeId: null,
          PlanTypeId: null,
          DeviceLogicTypeId: null,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (record?.SuperId) {
      getConfiguration(record.SuperId);
    }
  }, [record]);

  const handleSelectChange = (name, value) => {
    setConfigData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const saveConfiguration = async () => {
    try {
      setSaveLoading(true);

      const payload = {
        ...configData,
      };

      console.log(payload, "payload.............");

      // Same API for Add & Edit
      const res = await axios.post(
        `${API_BASE_URL}api/org/addconfiguration`,
        payload
      );

      if (res?.data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: isEdit
            ? "Configuration updated successfully"
            : "Configuration added successfully",
          confirmButtonText: "OK",
        }).then(() => {
          const modalElement = document.getElementById("configurationmodel");

          const modal = bootstrap.Modal.getInstance(modalElement);

          modal.hide();

          document
            .querySelectorAll(".modal-backdrop")
            .forEach((el) => el.remove());

          document.body.classList.remove("modal-open");

          document.body.style = "";
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res?.data?.message || "Something went wrong",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        confirmButtonText: "OK",
      });
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <div className="modal fade" id="configurationmodel">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {isEdit ? "Edit" : "Add"} Configuration -
              <span style={{ color: "orange" }}>{record?.OrgName}</span>
            </h4>

            <button
              id="closeAddCompanyModal"
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>

          <div className="modal-body">
            <Spin spinning={loading}>
              <div className="card border-0 shadow-sm mb-4">
                <div className="card-body">
                  <form>
                    <div className="row">
                      {/* Processing Type */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Processing Type
                            <span className="text-danger">*</span>
                          </label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            options={processingTypeOptions}
                            placeholder="Choose"
                            value={configData.ProcessingTypeId}
                            onChange={(value) =>
                              handleSelectChange("ProcessingTypeId", value)
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        </div>
                      </div>

                      {/* Priority Type */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Priority Type
                            <span className="text-danger">*</span>
                          </label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            options={priorityTypeOptions}
                            placeholder="Choose"
                            value={configData.PriorityTypeId}
                            onChange={(value) =>
                              handleSelectChange("PriorityTypeId", value)
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        </div>
                      </div>

                      {/* Product Type */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Product Type
                            <span className="text-danger">*</span>
                          </label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            options={productTypeOptions}
                            placeholder="Choose"
                            value={configData.ProductTypeId}
                            onChange={(value) =>
                              handleSelectChange("ProductTypeId", value)
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        </div>
                      </div>

                      {/* Plan Type */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">
                            Plan Type
                            <span className="text-danger">*</span>
                          </label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            options={planTypeOptions}
                            placeholder="Choose"
                            value={configData.PlanTypeId}
                            onChange={(value) =>
                              handleSelectChange("PlanTypeId", value)
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        </div>
                      </div>

                      {/* Device Logic */}
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label">DeviceLogic Type</label>

                          <Select
                            className="w-100"
                            style={{ height: 38 }}
                            options={deviceLogicOptions}
                            placeholder="Choose"
                            value={configData.DeviceLogicTypeId}
                            onChange={(value) =>
                              handleSelectChange("DeviceLogicTypeId", value)
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex justify-content-end mt-2">
                      <button
                        type="button"
                        className="btn btn-light me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={saveConfiguration}
                        disabled={saveLoading}
                      >
                        {saveLoading
                          ? isEdit
                            ? "Updating..."
                            : "Saving..."
                          : isEdit
                          ? "Update"
                          : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfigrationModel.propTypes = {
  record: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    OrgName: PropTypes.string,
    SuperId: PropTypes.number,
  }),
};

export default ConfigrationModel;
